import { useErrorToast } from "components/toast/ToastComponet";
import {
  FindBasicCardInfoClientFunctionFunction,
  FindCashTypeClientGraphicById,
  FindHistoryBkpById,
  FindInformationCardsClientById,
  FindTerminalsByClientId,
} from "functions/InfoClient";
import {
  FindClientsListByParmFunction,
  FindInactiveClientsFunction,
} from "functions/Usuarios";
import type {
  FindBasicInformationClientTypes,
  FindCashTypesParms,
  FindClientsListParms,
  FindInactiveClientsParms,
  GraphicGenerateTypes,
  ResponseCardClientParms,
  ResponseFindCashTypes,
  ResponseFindClientsListTypes,
  ResponseHistoryBkpTypes,
  ResponseInactiveClientsTypes,
  ResponseTerminalClientsTypes,
} from "types/clientsTypes";

export function useClients() {
  const toast = useErrorToast();

  const findClientsListByParms = async (
    parms: FindClientsListParms
  ): Promise<PaginateProps<ResponseFindClientsListTypes[]>> => {
    try {
      const resp: PaginateProps<ResponseFindClientsListTypes[]> =
        await FindClientsListByParmFunction(parms);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findInfosClientsById = async (
    clientId: number
  ): Promise<ResponseCardClientParms> => {
    try {
      const resp: ResponseCardClientParms =
        await FindInformationCardsClientById({ idClient: clientId });
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTerminalsByClientId = async (
    clientId: number
  ): Promise<PaginateProps<ResponseTerminalClientsTypes[]>> => {
    try {
      const resp: PaginateProps<ResponseTerminalClientsTypes[]> =
        await FindTerminalsByClientId({ idClient: clientId });
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findBKPListClientById = async (
    clientId: number
  ): Promise<PaginateProps<ResponseHistoryBkpTypes[]>> => {
    try {
      const resp: PaginateProps<ResponseHistoryBkpTypes[]> =
        await FindHistoryBkpById({ idClient: clientId });
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findCardClientsInformations = async (
    clientId: number
  ): Promise<FindBasicInformationClientTypes> => {
    try {
      const resp: FindBasicInformationClientTypes =
        await FindBasicCardInfoClientFunctionFunction({ idClient: clientId });
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findCashTypesGraphics = async (
    parms: FindCashTypesParms
  ): Promise<GraphicGenerateTypes> => {
    try {
      const resp: ResponseFindCashTypes[] = await FindCashTypeClientGraphicById(
        parms
      );

      const dataGraphics: GraphicGenerateTypes = {
        NUMERARIOS: {
          NOMES: resp.map((item: any) => item.NUMERARIO),
          VALORES: resp.map((item: any) => item.VALOR),
        },
      };

      return dataGraphics;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findInactiveClients = async (
    parms: FindInactiveClientsParms
  ): Promise<PaginateProps<ResponseInactiveClientsTypes[]>> => {
    try {
      const resp: PaginateProps<ResponseInactiveClientsTypes[]> =
        await FindInactiveClientsFunction(parms);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  return {
    findClientsListByParms,
    findInfosClientsById,
    findTerminalsByClientId,
    findBKPListClientById,
    findCardClientsInformations,
    findCashTypesGraphics,
    findInactiveClients,
  };
}
